import Modal from "../scripts/modal";
import simpleTabs from "../scripts/simple-tabs";
import inlineEditable from "../scripts/inline-editable";
import getSensorGroups from "../scripts/get-sensor-groups";
import PubSub from "pubsub-js";
import serialize from "form-serialize";
import manageSensorModal from '../views/manage-sensors-modal';

class editSensorModal {

  constructor(sensorId) {

    console.log(sensorId);

    this.sensor = null;

    new Promise((resolve, reject) => {

      apiRequest('get', '/sensor/' + sensorId).then(r => {
        if(r.type === 'success') {
          this.sensor = r.data;
          resolve();
        }
      });

    }).then(() => {

      this.renderModal();

    });

  }

  renderModal() {

    if(!this.sensor) return;

    console.log(this.sensor);

    const sensor = this.sensor;

    const modal = new Modal({
      class: ['modal'],
      title: 'Edit Sensor',
    });

    modal.setContent(manageSensorModal);

    const $modalContainer = $(modal.getContainer());

    // enterprise settings
    if(window.currentUser.use_sensor_groups == 1) {

      $modalContainer.find('.modal__tab-selector[data-for="alerts"]').hide();

      if(sensor.use_sensor_settings == 0) {

        $modalContainer.find('.sensor-modal--sensor-settings').hide();

      } else {
        $modalContainer.find('input[name="use_sensor_settings"]').attr('checked', true);
      }

      $modalContainer.find('input[name="use_sensor_settings"]').on('change', e => {

        if($(e.currentTarget).is(':checked')) {
          $modalContainer.find('.sensor-modal--sensor-settings').show();
        } else {
          $modalContainer.find('.sensor-modal--sensor-settings').hide();
        }

      });

      getSensorGroups().then(groups => {

        const $select = $modalContainer.find('form[data-for="group"] select[name="group"]');

        let html = '';

        groups.forEach(group => {
          html += `<option value="${group.id}" ${group.id === sensor.group ? 'selected' : ''}>${group.name}</option>`;
        });

        $select.html(html);

      });

    } else {
      $modalContainer.find('.modal__tab-selector[data-for="group"]').hide();
      $modalContainer.find('.sensor-modal--use-sensor-settings').hide();
    }

    simpleTabs($modalContainer.find('.modal__tabs-container'));

    $modalContainer.find('[name="send_interval"]').val(sensor.send_interval);
    $modalContainer.find('[name="alert_interval"]').val(sensor.alert_interval);

    if(sensor.alert_temp_below) {
      $modalContainer.find('[name="alert_temp_below"]').val(celsiusToUserTemp(sensor.alert_temp_below));
    }

    if(sensor.alert_temp_above) {
      $modalContainer.find('[name="alert_temp_above"]').val(celsiusToUserTemp(sensor.alert_temp_above));
    }

    $modalContainer.find('[name="alert_humidity_below"]').val(sensor.alert_humidity_below);
    $modalContainer.find('[name="alert_humidity_above"]').val(sensor.alert_humidity_above);

    $modalContainer.find('[name="temp_offset"]').val(sensor.temp_offset);
    $modalContainer.find('[name="humidity_offset"]').val(sensor.humidity_offset);

    [
      'use_alert_interval',
      'use_offset',
    ].forEach(toggleControl => {

      const el = $modalContainer.find(`[name="${toggleControl}"]`);

      // toggle on and off the container on click
      el.on('change', e => {

        if($(e.currentTarget).is(':checked')) {
          $modalContainer.find(`[data-for="${toggleControl}"]`).toggleClass('is-active', true);
        } else {
          $modalContainer.find(`[data-for="${toggleControl}"]`).toggleClass('is-active', false);
        }

      });

      if(sensor[toggleControl] == 1) {
        el.attr('checked', true);
        $modalContainer.find(`[data-for="${toggleControl}"]`).toggleClass('is-active', true);
      }

    });

    $modalContainer.find('[data-for="sensorId"]').val(sensor.sensor_id);
    $modalContainer.find('.modal__name').text(
      sensor.sensor_name && sensor.sensor_name.length > 0 ? sensor.sensor_name : sensor.sensor_id
    );

    const offlineContainer = $modalContainer.find('.modal__offline-status');
    if(sensor.offline == 1) {
      offlineContainer.toggleClass('is-offline', true);
      offlineContainer.html('Offline');
    } else {
      offlineContainer.toggleClass('is-offline', false);
      offlineContainer.html('Online');
    }

    $modalContainer.find('[data-for="temperature"]').html(celsiusToUserTemp(sensor.last_temp, 1) + `&deg;${window.getUserTempPref()}`);
    $modalContainer.find('[data-for="humidity"]').html(Math.round(sensor.last_humidity) + `%`);
    $modalContainer.find('[data-for="battery"]').html(getBatteryPercentage(sensor.last_voltage) + '%');
    $modalContainer.find('[data-for="sensor-id"]').html(sensor.sensor_id);

    const lastCheckinDate = window.getUserTimezoneDate(sensor.last_checkin);
    const nextCheckinDate = window.getUserTimezoneDate(sensor.next_checkin);

    let qualityValue = '';

    let connectionQuality = 0;
    let timeToConnect = 0;

    let rssi_low = 999;
    let rssi_high = -999;

    sensor.last_messages.forEach(message => {

      const rssi = parseInt(message.RSSI);

      connectionQuality += parseInt(rssi);
      timeToConnect += parseFloat(message.time_to_connect);

      if(rssi < rssi_low) {
        rssi_low = rssi;
      }

      if(rssi > rssi_high) {
        rssi_high = rssi;
      }

    });

    if(connectionQuality !== 0) {
      connectionQuality /= sensor.last_messages.length;
      connectionQuality = Math.round(connectionQuality);

      timeToConnect /= sensor.last_messages.length;
      timeToConnect = Math.round(timeToConnect);

      if (connectionQuality < -90) {
        qualityValue += `<img width="15" src="${window.site.home + '/images/wifi-no-signal.svg'}" title="Very bad signal quality (${connectionQuality} dB)" /> Little to no signal`;
      } else if (connectionQuality < -80) {
        qualityValue += `<img width="15" src="${window.site.home + '/images/wifi-no-bars.svg'}" title="Bad signal quality (${connectionQuality} dB)" /> Poor signal`;
      } else if (connectionQuality < -70) {
        qualityValue += `<img width="15" src="${window.site.home + '/images/wifi-half-bars.svg'}" title="Good signal quality (${connectionQuality} dB)" /> Good signal`;
      } else {
        qualityValue += `<img width="15" src="${window.site.home + '/images/wifi-full-bars.svg'}" title="Excellent signal quality (${connectionQuality} dB)" /> Excellent signal`;
      }

      qualityValue += `<div class="sensor-details__rssi-range">(${rssi_low} dB to ${rssi_high} dB)</div>`;
    } else {

      // old sensor not reporting rssi
      qualityValue = 'N/A';

    }

    $modalContainer.find('[data-for="last-checkin"]').html(lastCheckinDate.format('MMM D, h:mm a'));
    $modalContainer.find('[data-for="next-checkin"]').html(nextCheckinDate.format('MMM D, h:mm a'));
    $modalContainer.find('[data-for="mac-address"]').html(sensor.sensor_mac_addr ? sensor.sensor_mac_addr : 'N/A');

    let lastConnectTimeText = '';
    if(timeToConnect > 0) {
      lastConnectTimeText = `${timeToConnect} second`;

      if(timeToConnect > 1) {
        lastConnectTimeText += 's';
      }

    } else {
      lastConnectTimeText = 'N/A';
    }

    $modalContainer.find('[data-for="connect-time"]').html(lastConnectTimeText);

    $modalContainer.find('[data-for="wifi-quality"]').html(qualityValue);

    inlineEditable($modalContainer.find('.modal__name'), {
      onValidSubmission: value => {
        $.post({
          url: window.site.api + `/sensor/${sensor.sensor_id}`,
          dataType: 'json',
          data: {
            sensor_name: value,
          },
          success: r => {
            if(r.type == 'success') {
              PubSub.publish('sensors/updated', r.data);
            }
          }

        });
      }
    });

    apiRequest('get', '/alerts/all').then(r => {

      let html = '';

      r.data.forEach(alert => {
        html += `<option value="${alert.id}" ${sensor.alerts.includes(alert.id) ? 'selected' : ''}>${alert.alert_name}</option>`;
      });

      $modalContainer.find('[name="alerts"]').html(html);

    });

    const $buttons = $modalContainer.find('button[type="submit"]');

    $modalContainer.on('change', () => {
      $buttons.attr('disabled', false);
    });

    $modalContainer.on('submit', 'form', e => {

      e.preventDefault();

      const $form = $(e.currentTarget);
      const $message = $form.find('.form-modal-actions__message');

      $buttons.attr('disabled', true);
      $message.html('Saving...');

      const data = serialize($form[0], {hash: true});

      let endpoint = window.site.api + `/sensor/${sensor.sensor_id}`;

      if($form.data('for') == 'settings') {

        if(!data.use_sensor_settings) {
          data.use_sensor_settings = 0;
        }

        if (!data.use_alert_interval) {

          data.use_alert_interval = 0;

          // if not using alert interval, set the same as send_interval
          data.alert_interval = data.send_interval;

        }

        if (!data.use_offset) {
          data.use_offset = 0;
        }

      } else if($form.data('for') == 'alerts') {
        endpoint = window.site.api + `/sensor/${sensor.sensor_id}/alerts`;
      } else if($form.data('for') == 'group') {
        endpoint = window.site.api + `/sensor/${sensor.sensor_id}/group`;
      }

      apiRequest('post', endpoint, data).then(r => {

        if(r.type == 'error') {

          $message.toggleClass('is-error', true);
          $message.html(r.message);

        } else {

          $message.toggleClass('is-error', false);
          $message.html('');

          $buttons.attr('disabled', false);

          PubSub.publish(`sensors/updated`, r.data);
          PubSub.publish(`data-grid/sensors/updated`, r.data);

        }

      });

    });

    modal.open();

  }

}

export default editSensorModal;
